import { useState } from "react";
import arrowdown from '@features/projects/assets/arrow-down.svg';
import assignmentsStyles from '@features/assignments/styles/assignment.module.scss';

export interface UserItem {
  name: string;
  email: string;
}

interface AssignmentFormSelectProps {
  title: string;
  item: { name: string };
  setItem: (item: { name: string, email: string }) => void;
  list?: UserItem[];
}

export const AssignmentFormSelect = ({ title, item, setItem, list }: AssignmentFormSelectProps) => {
  const [style, setStyle] = useState("assignment-form-select__hide")

  const showHideUsersList = () => {
    if (style === "assignment-form-select__hide") {
      setStyle("assignment-form-select__show")
    } else {
      setStyle("assignment-form-select__hide")
    }
  }

  const handleSelect = (item: { name: string, email: string }) => {
    setStyle("assignment-form-select__hide")
    setItem(item)
  }

  return (
    <button className={assignmentsStyles["assignment-form-select__select"]}
      onClick={showHideUsersList}
      onMouseLeave={() => setStyle(assignmentsStyles["assignment-form-select__hide"])}
    >
      <span className={assignmentsStyles["assignment-form-select__team"]}>{title}</span>
      <span className={assignmentsStyles["assignment-form-select__whichteam"]}>{item.name}</span>
      <img src={arrowdown} className={assignmentsStyles["assignment-form-select__arrow"]} alt="arrow icon" />
      <div className={style}>
        {list?.map((user) => (
          <button className={assignmentsStyles["assignment-form-select__item"]} key={user.email} onClick={() => handleSelect(user)}>
            {user.name}
          </button>
        ))}
      </div>
    </button>
  )
}
